"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePasswordCriterias = void 0;
var PASSWORD_MIN_LENGTH = 8;
var PASSWORD_MAX_LENGTH = 20;
var validatePasswordCriterias = function (password) {
    var length = password.length >= PASSWORD_MIN_LENGTH && password.length <= PASSWORD_MAX_LENGTH;
    var casing = /[A-Z]/g.test(password) && /[a-z]/g.test(password);
    var digit = /\d/g.test(password);
    var special = /(?=.*[_!@#$%^&*)([\]?\\-])/g.test(password);
    return [length, casing, digit, special];
};
exports.validatePasswordCriterias = validatePasswordCriterias;
